
// eslint-disable-next-line import/prefer-default-export
export const AFFILIATION_ERROR_CODES = {
  PERMISSION_REQUIRED: 'permissionRequired',
  HAS_PRIMARY_AFFILIATION_ERROR: 'hasPrimaryAffiliation',
  NOT_FOUND_ERROR: 'notFound',
};
